import React, { memo } from 'react';
import { size, sortBy } from 'lodash';
import MarkersByTypeTemplate from './MarkersByTypeTemplate';

function ClusterManyMarkers({
 data, touchMarkerId, isMobile, onTouchStart, toggleZoom, $getDimensions, $geoService, $dimensionKey, openChangerModal, config,
}) {

  if (!size(data)) {
    return null
  }

  const sortedData = sortBy(data, ['markerClassName']);

  return (
    <MarkersByTypeTemplate
      markerClassName={sortedData[0].markerClassName}
      idOfMarkerOfCurrentType={sortedData[0].id}
      config={config}
      array={sortedData}
      hovered={touchMarkerId === sortedData[0].id}
      isMobile={isMobile}
      onTouchStart={onTouchStart}
      toggleZoom={toggleZoom}
      $getDimensions={$getDimensions}
      $dimensionKey={$dimensionKey}
      $geoService={$geoService}
      openChangerModal={openChangerModal}
    />
  );
}

export default memo(ClusterManyMarkers);
